export const ExternalLinkTypes = {
  GeneralPhoneLink: "tel:0402176065",
  GeneralPhoneText: "0402 176 065",
  GeneralEmailLink: "mailto:navi@itcians.com.au",
  GeneralEmailText: "navi@itcians.com.au",
};
